module.exports = external_api.BaseDataManager;